import React from "react";
import Container from "../../Component/Container/Container";
import { Wrapper, TopWrapper, Item, Heading, Image } from "./Gift.styled";
import COLORS from "../../Theme/Colors";
import Stories from "../Stories/Stories";

const Gift = () => {
  return (
    <Wrapper>
      <Container>
        <TopWrapper>
          <Item color={COLORS.whitesmoke}>
            <Heading>A Bloom of Love, Just for You</Heading>
            <Image src="./flower.png" alt="Flower" spin />
          </Item>
          <Item color={COLORS.beige}>
            <Heading>A Little Chick of Joy to Make You Smile</Heading>
            <Image src="./chick.png" alt="Chick" teeter />
          </Item>
        </TopWrapper>
        <Stories />
      </Container>
    </Wrapper>
  );
};

export default Gift;
